import TempoTrayAdSource from 'images/tempo-intro-ad-1.png';
import TempoChickenPiccata from 'images/tempo-intro-ad-2.png';
import WaveBorder from 'images/tempoWaveBorderDesktop.svg';

const AdSourceImageSection = () => (
  <>
    <div
      style={{ backgroundImage: `url(${WaveBorder})` }}
      className="-mt-px h-12 bg-repeat-x p-0 bp1:mb-8"
    />
    <div>
      <img
        className="absolute -right-6 -top-5 w-24 bp1:inset-1/2 bp1:top-28 bp1:w-52 bp1:translate-x-64 bp3:top-36"
        src={TempoTrayAdSource}
        alt="Tempo Garlic Sesame Chicken"
      />
      <img
        className="absolute -left-6 -top-5 w-24 bp1:inset-1/2 bp1:top-28 bp1:w-52 bp1:-translate-x-[32rem] bp3:top-36"
        src={TempoChickenPiccata}
        alt="Tempo Chicken Piccata"
      />
    </div>
  </>
);

export default AdSourceImageSection;
